import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { ActionsService } from '@app/@shared/services/web/actions.service';

@Component({
  selector: 'app-modal-succesfull-custom',
  templateUrl: './modal-succesfull-custom.component.html',
  styleUrls: ['./modal-succesfull-custom.component.scss'],
})
export class ModalSuccesfullCustomComponent implements OnInit {
  title = '';
  needValidateMsg = '';
  favoriteTab: boolean;
  id: string;

  alertCom: boolean;

  constructor(
    private actionsService: ActionsService,
    private readonly dialogRef: MatDialogRef<ModalSuccesfullCustomComponent>,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      savedSearch: boolean;
      needValidate: boolean;
      favorite: boolean;
      alert: boolean;
      undercover: boolean;
      message: string;
      alertCom: boolean;
    }
  ) {
    this.alertCom = data.alertCom;
  }

  ngOnInit(): void {
    this.validationsForMessage();
    this.validationsForIds();
  }

  close(): void {
    this.dialogRef.close();
    if (this.data.undercover) {
      this.actionsService.loginDone(true);
    }
  }

  validationsForMessage() {
    if (this.data?.savedSearch) {
      this.title = 'components.modalSuccesfull.savedSearch';
    }
    if (this.data?.needValidate) {
      this.needValidateMsg = 'components.modalSuccesfull.needValidateEmail';
    }
    if (this.data?.favorite === true) {
      this.title = 'components.modalSuccesfull.savedFavorite';
      this.favoriteTab = this.data?.favorite;
    }
  }

  validationsForIds() {
    const newUserAlert = this.data?.alert && this.data?.needValidate;
    const oldUserAlert = this.data?.alert && !this.data?.needValidate;
    const newUserFavorite = this.data?.favorite && this.data?.needValidate;
    const oldUserFavorite = this.data?.favorite && !this.data?.needValidate;
    const newUserSearch = this.data?.savedSearch && this.data?.needValidate;
    const oldUserSearch = this.data?.savedSearch && !this.data?.needValidate;

    if (newUserAlert) {
      this.id = 'CTA-newUserAlert';
    } else if (oldUserAlert) {
      this.id = 'CTA-oldUserAlert';
    } else if (newUserFavorite) {
      this.id = 'CTA-newUserFavorite';
    } else if (oldUserFavorite) {
      this.id = 'CTA-oldUserFavorite';
    } else if (newUserSearch) {
      this.id = 'CTA-newUserSearch';
    } else if (oldUserSearch) {
      this.id = 'CTA-oldUserSearch';
    }
  }
}
